import { Component, h } from 'preact';


interface Props {
  value: number;
  party?: string;
  // Custom candidate color, used in place of the party color when set
  color?: string;
}

interface State {
  direction: 'up' | 'down' | null;
  // Bumped on each change so the fade animation restarts
  changeCount: number;
}

// How long the arrow stays up, including its fade out (see .pct-change__arrow)
const VISIBLE_MS = 5000;

// Spelled out in full so PurgeCSS (config/tasks/unused-css.js) keeps them.
// Same party colors as the PartyPill circles.
const PARTY_CLASSES: { [prefix: string]: string } = {
  rep: 'pct-change--rep',
  dem: 'pct-change--dem',
  lib: 'pct-change--lib',
  ind: 'pct-change--ind',
  gre: 'pct-change--gre',
};

// Compare what readers see, so tiny shifts that round away don't flip the arrow
const rounded = (n: number) => Math.round(n * 10) / 10;

// Arrow that briefly shows whether a percent rose or fell in a results refresh
class PctChange extends Component<Props, State> {
  state: State = { direction: null, changeCount: 0 };
  timer: number;

  componentWillReceiveProps(nextProps: Props) {
    const prev = rounded(this.props.value);
    const next = rounded(nextProps.value);

    if (next !== prev) {
      window.clearTimeout(this.timer);
      this.setState({
        direction: next > prev ? 'up' : 'down',
        changeCount: this.state.changeCount + 1,
      });
      this.timer = window.setTimeout(
        () => this.setState({ direction: null }),
        VISIBLE_MS
      );
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.timer);
  }

  render({ party, color }: Props, { direction, changeCount }: State) {
    const partyClass = party && PARTY_CLASSES[party.slice(0, 3).toLowerCase()];

    return (
      <span
        class={partyClass ? `pct-change ${partyClass}` : 'pct-change'}
        style={color ? { color } : undefined}
      >
        {direction && (
          <span key={changeCount} class="pct-change__arrow">
            <svg aria-hidden="true">
              <use
                xlinkHref={direction === 'up' ? '#icon-up-arrow' : '#icon-down-arrow'}
              />
            </svg>
            <span class="is-sr-only">{direction === 'up' ? 'Up' : 'Down'}</span>
          </span>
        )}
      </span>
    );
  }
}

export default PctChange;
